import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { Flex } from "@faire/web--source/slate/Layout";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
import { MobileDottedTooltip } from "./MobileDottedTooltip";
import { DesktopDottedTooltip } from "./DesktopDottedTooltip";
export var DottedTooltip = function(props) {
    var isMobile = useViewport().isMobile;
    return /*#__PURE__*/ _jsx(Flex, {
        children: isMobile ? /*#__PURE__*/ _jsx(MobileDottedTooltip, _object_spread({}, props)) : /*#__PURE__*/ _jsx(DesktopDottedTooltip, _object_spread({}, props))
    });
};
